<div class="title">{{ description }}</div>
<ng-content></ng-content>
